export const ThickDivider = () => {
    return <div style={{ height: 16, backgroundColor: '#f7f7f7' }} />;
};
